import { render } from "./LicenseModal.vue?vue&type=template&id=5f81f3e0&scoped=true"
const script = {}

import "./LicenseModal.vue?vue&type=style&index=0&id=5f81f3e0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jamesc\\source\\repos\\ul-web-plugins\\src\\UL.VueCadPlugin.Client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f81f3e0"]])

export default __exports__